"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.5 3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.905c-.944-.844-2.29-1.328-3.67-1.464A7.5 7.5 0 1 0 19.5 12a.5.5 0 0 1 1 0 8.5 8.5 0 1 1-7.667-8.459c1.477.146 3.024.662 4.167 1.65V3.5a.5.5 0 0 1 .5-.5"
}), 'Refresh');
//# sourceMappingURL=index.js.map